
import { supabaseCustomRole } from "@/lib/supabase/customRoleClient";
import { Dealer } from "@/types/dealer";

export const fetchDealersData = async (): Promise<Dealer[]> => {
  try {
    console.log("Fetching dealers data from vw_dealers_with_ratings...");
    
    // Fetch all dealers with ratings using the view
    const { data: dealersData, error: dealersError } = await supabaseCustomRole
      .from("vw_dealers_with_ratings")
      .select("*");
      
    if (dealersError) {
      console.error("Error fetching dealers:", dealersError);
      throw dealersError;
    }
    
    if (!dealersData) {
      return [];
    }
    
    console.log(`Successfully fetched ${dealersData.length} dealers with ratings`);
    
    // Fetch all dealer IDs for quotations
    const dealerIds = dealersData.map(dealer => dealer.id);
    
    // Fetch quotations data for all dealers
    const { data: quotationsData, error: quotationsError } = await supabaseCustomRole
      .from("dealer_quotations")
      .select("dealer_id, metal, spread_percentage, spread_fixed, spread_type")
      .eq("metal", "ORO");
      
    if (quotationsError) {
      console.error("Error fetching quotations:", quotationsError);
    }
    
    // Process quotations
    const dealerQuotations: Record<string, number> = {};
    
    if (quotationsData) {
      dealerIds.forEach(dealerId => {
        const dealerSpecs = quotationsData.filter(q => q.dealer_id === dealerId);
        
        if (dealerSpecs.length > 0) {
          const latestQuotation = dealerSpecs[0];
          dealerQuotations[dealerId] = latestQuotation.spread_type === "FIXED"
            ? latestQuotation.spread_fixed
            : latestQuotation.spread_percentage;
        }
      });
    }
    
    // Format and return dealer data
    const formattedDealers = dealersData.map(dealer => {
      // Get rating - already in the view as average_rating
      const rating = parseFloat(dealer.average_rating) || 0;
      
      const formattedDealer: Dealer = {
        id: dealer.id,
        name: dealer.name,
        address: dealer.address,
        city: dealer.city,
        rating: rating,
        is_verified: dealer.activated || false,
        activated: dealer.activated || false,
        isFavorite: false, // This will be updated by the store later
        latitude: dealer.latitude,
        longitude: dealer.longitude,
        buySpread: dealerQuotations[dealer.id],
        image_url: dealer.image_url,
        postal_code: dealer.postal_code,
        license: dealer.license,
        opening_hours: dealer.opening_hours,
        phone: dealer.phone,
        website: dealer.website,
        email: dealer.email
      };
      
      return formattedDealer;
    });
    
    return formattedDealers;
  } catch (error) {
    console.error("Error in fetchDealersData:", error);
    return [];
  }
};
